import { userErrorFragment } from './fragmentGeneral.gql';
import cartFragment from './fragmentCart.gql';

const cartLinesAdd = (
	`mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!, $consent: VisitorConsent) @inContext(visitorConsent: $consent) {
		cartLinesAdd(cartId: $cartId, lines: $lines) {
			userErrors ${userErrorFragment}
			cart ${cartFragment}
		}
	}`
);

export default cartLinesAdd;
